import { Link } from "react-router-dom";
import apartmentRoomImg from "@/assets/apartment-kitchen.png";
import { useLanguage } from "@/i18n/LanguageContext";
import { useCmsContent } from "@/hooks/useCmsContent";

const HomeApartments = () => {
  const { t } = useLanguage();
  const { get } = useCmsContent();

  return (
    <section className="hotel-section bg-secondary">
      <div className="hotel-container">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-12">
          <p className="hotel-caption text-accent mb-4">{get("apartments_caption") || t.homeApartments.caption}</p>
          <h2 className="hotel-heading text-foreground mb-6">{get("apartments_heading") || t.homeApartments.heading}</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-4 md:gap-8">
          <div className="space-y-3">
            {t.homeApartments.amenities.map((item) => (
              <div key={item} className="px-4 py-3 rounded-sm" style={{ backgroundColor: '#a17e48' }}>
                <span className="font-body text-sm font-medium text-white">{item}</span>
              </div>
            ))}
          </div>
          <div className="flex flex-col bg-card rounded-lg overflow-hidden shadow-soft">
            <div className="p-6 md:p-8 text-center flex-1 flex flex-col justify-center">
              <h3 className="font-display text-xl md:text-2xl font-semibold text-primary mb-4">
                {get("apartments_book_title") || t.homeApartments.bookTitle}
              </h3>
              <p className="font-body text-sm text-muted-foreground leading-relaxed">
                {get("apartments_book_text") || t.homeApartments.bookText}
              </p>
            </div>
            <div className="bg-primary p-4 text-center">
              <Link to="/contact" className="font-body text-sm text-primary-foreground font-medium hover:text-accent transition-colors">
                {t.homeApartments.contactLink}
              </Link>
            </div>
          </div>
          <div className="rounded-lg overflow-hidden shadow-soft">
            <img src={apartmentRoomImg} alt="Apartment" loading="lazy" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeApartments;
